import * as React from "react";
const SvgFiRrCandyAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-candy-alt_svg__a)">
      <path
        fill="#062147"
        d="M15.715.036C7.968-.714 3.05 8.681 7.975 14.611L.293 22.293a1 1 0 0 0 1.414 1.414l7.682-7.682C15.07 20.742 24.107 16.446 24 9A9.006 9.006 0 0 0 15.715.036M15 16a7.01 7.01 0 0 1-7-7C7.786 1.742 19.233-1.307 20 7a5.006 5.006 0 0 1-5 5 3 3 0 0 1 0-6 1.07 1.07 0 0 1 1 1 1 1 0 0 1-1 1 1 1 0 1 0 0 2 3 3 0 1 0 0-6 5.006 5.006 0 0 0-5 5c.606 7.788 11.2 5.628 11.92-1A7.01 7.01 0 0 1 15 16"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-candy-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCandyAlt;
